import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import {first, map} from 'rxjs/operators';

import {basePath} from '@atmi/core/injection';
import {Base, ResponsePaginateSuccess, ResponseSuccess} from '@atmi/core/models';
import {generateIndexQueryString, IndexQueryStringType} from '@atmi/core/utils';
import {Observable} from "rxjs";

@Injectable()
export class BaseApiService {

  private readonly url = `${this.baseUrl}/basi`;

  constructor(
    @Inject(basePath) private readonly baseUrl: string,
    private readonly http: HttpClient,
  ) {
  }

  index(queryString?: IndexQueryStringType) {
    const params = generateIndexQueryString(queryString);

    return this.http.get<ResponsePaginateSuccess<Base[]>>(this.url, {params}).pipe(
      map((res) => ({data: res.data, count: res.count})),
      first(),
    );
  }

  get(id: string): Observable<Base> {
    return this.http.get<ResponseSuccess<Base>>(`${this.url}/${id}`).pipe(
      map((res) => res.data),
      first(),
    );
  }

  post(base: Base) {
    return this.http.post<ResponseSuccess<Base>>(this.url, base).pipe(
      map((res) => res.data),
      first(),
    );
  }

  put(base: Base) {
    return this.http.put<ResponseSuccess<Base>>(`${this.url}/${base.id}`, base).pipe(
      map((res) => res.data),
      first(),
    );
  }

  remove(id: string) {
    return this.http.delete(`${this.url}/${id}`).pipe(first());
  }
}
